import React from 'react';

interface GridMenuIconProps {
  onClick: () => void;
}

export function GridMenuIcon({ onClick }: GridMenuIconProps) {
  return (
    <button
      onClick={onClick}
      className="p-2 hover:bg-black/20 rounded-lg transition-colors"
    >
      <div className="grid grid-cols-2 gap-1 w-7 h-7">
        <div className="bg-current rounded-sm"></div>
        <div className="bg-current rounded-sm"></div>
        <div className="bg-current rounded-sm"></div>
        <div className="bg-current rounded-sm"></div>
      </div>
    </button>
  );
}